import { createStore, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { reducers } from "../reducers";
import { coinList, marketData } from "../actions/market";
import { favoriteCoins } from "../actions/favoriteCoins";
import { addUserHashCode } from "../actions/user";

//Reducer ha ro combine mikonim va midim be createStore
export const store = createStore(
  reducers,
  compose(
    applyMiddleware(thunk)
    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  )
);

store.subscribe(() => console.log(store.getState()));
// store.dispatch(coinList());
store.dispatch(marketData());
store.dispatch(addUserHashCode());
store.dispatch(favoriteCoins());
